import { Reveal } from "./Reveal";
import { CTAButton } from "./CTAButton";

export const CTABanner = ({ title, buttonLabel, testid }) => (
  <section className="relative overflow-hidden bg-brand-600" data-testid="cta-banner">
    <div
      className="absolute -top-24 -right-24 h-72 w-72 rounded-full border-[40px] border-white/10"
      aria-hidden="true"
    />
    <div
      className="absolute -bottom-32 -left-16 h-80 w-80 rounded-full border-[56px] border-white/5"
      aria-hidden="true"
    />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
      <Reveal>
        <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-white max-w-xl">
          {title}
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <CTAButton variant="white" testid={testid}>
          {buttonLabel}
        </CTAButton>
      </Reveal>
    </div>
  </section>
);
